import { useEffect } from "react";
import { ConstantImport } from "../../Constants/ConstantImport";
import { SiteResponse } from "src/Data/Responses/SiteResponse";
import { SiteWindowResponse } from "src/Data/Responses/SiteWindowResponse";

interface CommentatorProps {
    Display: boolean
    SiteProperties: SiteResponse | undefined,
    SiteTimeWindows: Array<SiteWindowResponse> | undefined
}

export function Commentator(props: CommentatorProps) {
    const c = document.createComment(`
#========
# Check environmental and build data here.
# Visible only to members of SPMANS.
#========
      
ConstantImport: ` + JSON.stringify(ConstantImport, null, 2) + `

SiteProperties: ` + JSON.stringify(props.SiteProperties, null, 2) + `

SiteTimeWindows: ` + JSON.stringify(props.SiteTimeWindows, null, 2) + `
`);

    useEffect(() => {
        if (props.Display && props.SiteProperties !== undefined && props.SiteTimeWindows !== undefined && document.lastChild?.textContent !== c.textContent) {
            document.appendChild(c);
        } else if (!props.Display || props.SiteProperties === undefined || props.SiteTimeWindows === undefined) {
            if (document.lastChild?.textContent === c.textContent) {
                document.removeChild(document.lastChild);
            }
        }
    });

    return <></>;
}